export default __webpack_public_path__ + "static/media/sickle-cell-mobile.ad6f95cd.png";